import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ContextService} from './context.service';
import {CreateUpdateSOICampaignModel, SOICampaignModel, SOICampaignsGridModel, SOICampaignsPersonModel, SOICampaignsSupporterGridModel, SupportersByWeek} from '@app/models/soi-campaigns.model';

@Injectable({
  providedIn: 'root',
})
export class SOICampaignsService {
  constructor(private http: HttpClient, private contextService: ContextService) {
  }

  getSOICampaignsPrimeNG(dataMode: string, organizationId: number, filterData): Observable<SOICampaignsGridModel> {
    return this.http.post<SOICampaignsGridModel>(`${this.contextService.contextObject.apiBaseUrlV1}/api/1.0/organizing/soi/campaign/grid/${organizationId}?mode=${dataMode}`, filterData);
  }

  getSOICampaign(soiCampaignId: number): Observable<SOICampaignModel> {
    return this.http.get<SOICampaignModel>(`${this.contextService.contextObject.apiBaseUrlV1}/api/1.0/organizing/soi/campaign/${soiCampaignId}`);
  }

  getUnauthSOICampaign(soiGuidId: string): Observable<SOICampaignModel> {
    return this.http.get<SOICampaignModel>(`${this.contextService.contextObject.apiBaseUrlV1}/api/1.0/organizing/soi/campaign/${this.contextService.contextObject.tenantName}/byguid/${soiGuidId}`);
  }

  createSOICampaign(modelData: CreateUpdateSOICampaignModel): Observable<SOICampaignModel> {
    return this.http.post<SOICampaignModel>(`${this.contextService.contextObject.apiBaseUrlV1}/api/1.0/organizing/soi/campaign/create`, modelData);
  }

  updateSOICampaign(soiCampaignId: number, modelData: CreateUpdateSOICampaignModel): Observable<SOICampaignModel> {
    return this.http.put<SOICampaignModel>(`${this.contextService.contextObject.apiBaseUrlV1}/api/1.0/organizing/soi/campaign/${soiCampaignId}`, modelData);
  }

  deleteSOICampaign(soiCampaignId: number): Observable<any> {
    return this.http.delete<any>(`${this.contextService.contextObject.apiBaseUrlV1}/api/1.0/organizing/soi/campaign/remove/${soiCampaignId}`);
  }

  getStatsSupportersByWeek(soiCampaignId: number): Observable<SupportersByWeek> {
    return this.http.get<SupportersByWeek>(`${this.contextService.contextObject.apiBaseUrlV1}/api/1.0/organizing/soi/campaign/${soiCampaignId}/stats/supportersbyweek`);
  }

  getStatsDonationsByWeek(soiCampaignId: number): Observable<any> {
    return this.http.get<any>(`${this.contextService.contextObject.apiBaseUrlV1}/api/1.0/organizing/soi/campaign/${soiCampaignId}/stats/donationsbyweek`);
  }

  getSOICampaignSupporters(soiCampaignId: number, filterModel): Observable<SOICampaignsPersonModel> {
    return this.http.post<SOICampaignsPersonModel>(`${this.contextService.contextObject.apiBaseUrlV1}/api/1.0/organizing/soi/campaign/${soiCampaignId}/person/grid`, filterModel);
  }

  getSOISupporterCampaigns(personID: number, filterModel): Observable<SOICampaignsSupporterGridModel> {
    return this.http.post<SOICampaignsSupporterGridModel>(`${this.contextService.contextObject.apiBaseUrlV1}/api/1.0/superuser/roster/${personID}/campaigngrid`, filterModel);
  }

  updateSOICampaignSupporter(personID: number, campaignId: number, modelData): Observable<SOICampaignsGridModel> {
    return this.http.put<SOICampaignsGridModel>(`${this.contextService.contextObject.apiBaseUrlV1}/api/1.0/organizing/soi/campaign/${campaignId}/person/${personID}`, modelData);
  }


}
